import * as React from "react";
import styled from "styled-components";

import * as Styles from "@/utils/styles";

// ========================= //
// ↓↓↓ Styled Components ↓↓↓ //
// ========================= //

const SVG = styled("svg").attrs(() => ({
	id: "logo-text",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 15 10",
}))`
	fill: ${Styles.Colors.LIGHT.seven};
	transition: 0.15s ease-in;

	:hover {
		fill: ${Styles.Colors.PRIMARY};
	}
`;

// ================= //
// ↓↓↓ Component ↓↓↓ //
// ================= //

type Props = {
	height?: number;
};

export const LogoText = (props: Props) => {
	return (
		<SVG height={props.height || "10"}>
			<path d="M0 4.203V.065h.877v3.414h1.678v.725H0zm7.034-2.075c0 .685-.17 1.211-.509 1.579s-.826.552-1.461.552-1.121-.184-1.461-.552-.509-.896-.509-1.585.17-1.214.509-1.577S4.433 0 5.069 0s1.122.183 1.458.549.507.893.507 1.579zm-3.02 0c0 .462.088.81.263 1.044s.438.351.787.351c.7 0 1.05-.465 1.05-1.395S5.766.73 5.069.73c-.349 0-.612.118-.79.354s-.266.582-.266 1.044zm5.166-.359l.863-1.704h.945L9.615 2.593v1.611h-.872V2.621L7.371.065h.951l.858 1.704zm5.763.326c0 .681-.194 1.203-.583 1.565s-.946.543-1.678.543h-1.172V.065h1.299c.675 0 1.2.178 1.574.535s.56.855.56 1.494zm-.911.023c0-.889-.393-1.333-1.178-1.333h-.467v2.695h.376c.845 0 1.268-.454 1.268-1.361zM3.329 10h-.996L1.248 8.256l-.371.266V10H0V5.862h.877v1.894l.345-.487 1.121-1.407h.974L1.874 7.693 3.329 10zm.521 0V5.862h.877V10h-.877zm3.671 0l-.996-3.247h-.025l.054 1.322V10h-.784V5.862h1.194l.979 3.164h.017l1.039-3.164h1.194V10h-.818V8.041l.003-.32.04-.962h-.025L8.324 10h-.804z" />
		</SVG>
	);
};
